import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher() {
  console.log('🌍 LanguageSwitcher component is mounting...');

  // Move useTranslation to top level - NEVER call hooks inside try-catch
  const { i18n } = useTranslation();

  console.log('✅ LanguageSwitcher rendered! Current language:', i18n.language);

  const toggleLanguage = () => {
    try {
      const currentLang = i18n.language;
      const newLang = currentLang === 'ko' ? 'en' : 'ko';
      console.log('🔄 Switching language from', currentLang, 'to:', newLang);
      i18n.changeLanguage(newLang).then(() => {
        console.log('✅ Language changed successfully to:', i18n.language);
      }).catch((error) => {
        console.error('❌ Error changing language:', error);
      });
    } catch (error) {
      console.error('❌ Error in toggleLanguage:', error);
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white hover:bg-gray-50 border border-gray-200 transition-colors"
      title={i18n.language === 'ko' ? "Switch to English" : "한국어로 전환"}
    >
      <Globe className="w-5 h-5 text-gray-600" />
      <span className="font-medium text-gray-700">
        {i18n.language === 'ko' ? 'EN' : '한국어'}
      </span>
    </button>
  );
}
